const v32 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...state.options.tableViews.invoicesTable,
          'True Receiver': true,
        },
      },
    },
  };
};

export default v32;
